module.exports = __webpack_public_path__ + "static/media/IMG_2737.d52a5386.jpg";